import { defineStore } from "pinia";

export interface GlobalState {
  loading: boolean;
  mySkills: UserSkill[];
  mySkillsInitialized: boolean;
}
export const useGlobalStore = defineStore("globalStore", {
  state: (): GlobalState => ({
    loading: false,
    mySkills: [],
    mySkillsInitialized: false
  }),
  actions: {
    changeLoading(loading: boolean) {
      this.loading = loading;
    },
    setMySkills(skills: UserSkill[]) {
      this.mySkills = skills;
    },
    addMySkill(skill: UserSkill) {
      this.mySkills = [...this.mySkills, skill];
    },
    removeMySkill(skillId: number) {
      this.mySkills = this.mySkills.filter((skill) => skill.id !== skillId);
    },
    async refreshMySkills() {
      const response = await useUserRepository().getMySkills();
      const { data, error } = response;
      if (!error && data) {
        this.mySkills = data;
        this.mySkillsInitialized = true;
      }
      return response;
    },
    async initMySkills() {
      if (this.mySkillsInitialized) return;
      await this.refreshMySkills();
    }
  }
});
